import React from 'react';
import { connect } from 'react-redux';
import { scheduleCalendarOperations } from 'pages/ScheduleCalendar/duck';
import { ManageApplicantModalComponent } from './ManageApplicantModalComponent';

const mapStateToProps = ({
  scheduleCalendarReducer,
}) => {
  return {
    allUsers: scheduleCalendarReducer.allUsers.users,
    applicants: scheduleCalendarReducer.applicants.data,
  };
};

const mapDispatchToProps = (dispatch) => {
  
  const approveApplicantDispatch = (shiftId, applicant) => {
    dispatch(scheduleCalendarOperations.approveApplicantOperation(shiftId, applicant));
  };
    
  const denyApplicantDispatch = (shiftId, applicant) => {
    dispatch(scheduleCalendarOperations.denyApplicantOperation(shiftId, applicant));
  };

  return {
    approveApplicantDispatch,
    denyApplicantDispatch,
  };
};

const ManageApplicantModalComponentContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)((props) => {
  const {
    approveApplicantDispatch,
    denyApplicantDispatch,
    } = props;

  return <ManageApplicantModalComponent
    approveApplicantDispatch = {approveApplicantDispatch}
    denyApplicantDispatch = {denyApplicantDispatch}
    {...props}
   /> 
});

export default ManageApplicantModalComponentContainer;